import { DestroyRef, inject, Injectable, signal } from "@angular/core";
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Router,
} from "@angular/router";
import { filter } from "rxjs";

@Injectable({ providedIn: "root" })
export class LoadingService {
  private router = inject(Router);
  private activeRequests = 0;
  private minDisplayTime = 300;
  private loadingStartTime: number | null = null;
  private isNavigating = false;
  readonly loading = signal(false);
  private destroyRef = inject(DestroyRef);

  constructor() {
    const subscription = this.router.events
      .pipe(
        filter(
          (event) =>
            event instanceof NavigationEnd ||
            event instanceof NavigationCancel ||
            event instanceof NavigationError,
        ),
      )
      .subscribe(() => {
        this.isNavigating = false;
        this.hideLoadingIfReady();
      });

    this.destroyRef.onDestroy(() => subscription.unsubscribe());
  }

  startLoading() {
    if (this.activeRequests === 0) {
      this.loadingStartTime = Date.now();
      this.loading.set(true);
      this.isNavigating = true;
    }
    this.activeRequests++;
  }

  onRequestComplete() {
    this.activeRequests--;

    if (this.activeRequests <= 0) {
      this.activeRequests = 0;
      this.hideLoadingIfReady();
    }
  }

  private hideLoadingIfReady() {
    if (this.isNavigating) {
      return;
    }

    if (this.activeRequests > 0) {
      return;
    }

    if (this.loadingStartTime) {
      const elapsed = Date.now() - this.loadingStartTime;
      const remaining = Math.max(0, this.minDisplayTime - elapsed);

      setTimeout(() => {
        this.loading.set(false);
        this.loadingStartTime = null;
      }, remaining);
    } else {
      this.loading.set(false);
    }
  }
}
